import { queryOptions, skipToken, useQuery } from "@tanstack/react-query";
import api from "../api";
import urls from "../urls";
import type { GhostNode } from "../utils/backend-types";

export const ghostNodeQueries = {
  detail: (ghostNodeId?: number) =>
    queryOptions<GhostNode>({
      queryKey: ["ghostNode", { ghostNodeId }],
      queryFn: ghostNodeId ? () => fetchGhostNode(ghostNodeId) : skipToken
    })
};

export function useGhostNode(ghostNodeId?: number) {
  return useQuery(ghostNodeQueries.detail(ghostNodeId));
}

async function fetchGhostNode(ghostNodeId: number) {
  const response = await api.get<GhostNode>(urls.api.ghostNode(ghostNodeId));
  return response.data;
}
